export default {
  SCAN_QR_TOKEN_START: 'ScanQrTokenStart',
  SCAN_QR_TOKEN_END: 'ScanQrTokenEnd'
};
